import {memo, useCallback, useState} from 'react';
import {Chart} from "react-google-charts";
import TD from "../DataTable/TD";
import {useTranslation} from "react-i18next";
import {Typography} from "@material-tailwind/react";
import Loader from "../../assets/icons/Loader";

export interface LocationsChartProps {
    series: any[],
    extra: any[],
    isLoading: boolean
}

const LocationsChart = ({series, extra, isLoading = true}: LocationsChartProps) => {
    const colors = [
        '#ffca28',
        '#9ccc65',
        '#26a69a',
        '#d84315',
        '#039be5',
        '#9c27b0',
        '#ff5722',
        '#ef5350',
        '#33691e',
        '#00695c'
    ];

    const {t} = useTranslation();
    const element = document.getElementById('locations_chart');
    const [chart, setChart] = useState<any>();

    const setSelected = useCallback((id: number) => {
        if (!chart)
            return;
        chart.getChart().setSelection([{row: id, column: 1}]);
    }, [chart]);

    const table = () => {
        if (series.length < 2)
            return [];
        const nc: string[] = [];
        const step = parseFloat(extra[0][0]) / colors.length;
        for (let i = 0; i < extra.length; i++) {
            const colorID = Math.floor(parseFloat(extra[i][0]) / step) - 1;
            nc[i] = colors[colorID > 0 ? colorID : 0] ?? '';
        }

        const t: object[] = [];
        for (let i = 1; i < series.length; i++) {
            t.push([nc[i - 1], i, series[i][0], series[i][1], extra[i - 1][0]]);
        }

        return t;
    }


    return <div className="grid md:grid-cols-3 gap-4">
        <div className="md:col-span-2 flex items-center justify-center">
            <Chart className="pb-0 inline-block" chartType="GeoChart"
                   width={element ? (element.offsetWidth / 2) - 16 : '100%'}
                   height={element ? element.offsetHeight - 100 : '100%'}
                   chartEvents={[
                       {
                           eventName: "ready",
                           callback: ({chartWrapper}) => {
                               setChart(chartWrapper);
                           }
                       }
                   ]}
                   options={{
                       backgroundColor: 'transparent',
                       datalessRegionColor: '#cfd8dc',
                       colorAxis: {colors: colors},
                       legend: "none",
                       tooltip: {
                           showColorCode: true,
                       }
                   }}
                   data={series.length > 1 ? series : [series[0].slice(0,2)]}/>
        </div>
        <div className={`overflow-x-none overflow-y-auto lg:h-72 flex justify-center pr-2 ${series.length < 2? 'items-center lg:items-start': 'items-start'}`}>
            {series.length > 1 &&
            <table className="w-full table table-striped locations-table">
                <thead>
                <tr className="text-left text-black dark:text-white">
                    <th className="font-thin w-4"></th>
                    <th className="font-thin">#</th>
                    <th className="font-thin">{t('admin.charts.locations_table.country')}</th>
                    <th className="font-thin text-right">{t('admin.charts.locations_table.transactions')}</th>
                    <th className="font-thin text-right">{t('admin.charts.locations_table.percent')}</th>
                </tr>
                </thead>
                <tbody>
                {table().map((i, index) => <tr key={i[1]}>
                    <TD className="w-4 p-[0.25rem!important] cursor-pointer"><span onClick={() => setSelected(index)}
                        className="w-3 h-3 rounded-full inline-block" style={{backgroundColor: i[0]}}/></TD>
                    <TD className=" p-[0.25rem!important]">{i[1]}</TD>
                    <TD className=" p-[0.25rem!important]">{i[2]}</TD>
                    <TD className="p-[0.25rem!important] text-right">{i[3]}</TD>
                    <TD className="text-right p-[0.25rem!important]">{i[4]}</TD>
                </tr>)}
                </tbody>
            </table>
            }
            {series.length <2 && !isLoading && <Typography variant="small" className="-mt-8 md:mt-0 h-auto inline-block mb-4 relative">{t('No data')}</Typography>}
        </div>
        {isLoading ? <div
            className="absolute w-full h-full bg-white dark:bg-black top-0 left-0 opacity-30 flex items-center justify-center rounded-xl">
            <Loader width="w-8 h-8" colors="text-teal-600 fill-white"/>
        </div> :''}
    </div>;
}

export default memo(LocationsChart);
